export default "/assets/images/carbon-filter.webp?d100d590ea816b655dceae3ee72433e1";